/**
 * Persists the auth provider a user last signed in with so the login UI can
 * show a hint next to the matching button. Stored in localStorage because it
 * is a non-sensitive UI preference scoped to the browser/device.
 */

export type LoginMethod = "google" | "apple" | "microsoft" | "credentials";

const STORAGE_KEY = "medly.lastLoginMethod";

function isLoginMethod(value: string): value is LoginMethod {
  return (
    value === "google" ||
    value === "apple" ||
    value === "microsoft" ||
    value === "credentials"
  );
}

export function setLastLoginMethod(method: LoginMethod): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, method);
  } catch {
    // Ignore storage failures (private mode, quota, disabled, etc.)
  }
}

export function getLastLoginMethod(): LoginMethod | null {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value != null && isLoginMethod(value) ? value : null;
  } catch {
    return null;
  }
}
